/** 二期/三期页面的占位，避免导航点进去白屏。 */
export function PlaceholderPage({ title }: { title: string }) {
  return (
    <main className="page">
      <h1>{title}</h1>
      <p className="empty-state">该模块正在重建中，暂未开放。</p>
    </main>
  );
}
